import PropTypes from "prop-types";
import React from "react";

import Loader from "./Loader";

const ActionButton = ({ type, inProgress, children, ...other }) => {
  const hasLightText = type === "positive" || type === "negative";

  return (
    <button
      {...other}
      type="submit"
      className={`u-no-margin--bottom ${type ? `p-button--${type}` : ""}`}
    >
      {inProgress ? (
        <Loader text={children} isLight={hasLightText} />
      ) : (
        children
      )}
    </button>
  );
};

ActionButton.propTypes = {
  children: PropTypes.string.isRequired,
  type: PropTypes.oneOf([undefined, "base", "neutral", "negative", "positive"]),
  inProgress: PropTypes.bool
};

ActionButton.defaultProps = {
  type: undefined,
  inProgress: false
};

export default ActionButton;
